const TABS = [
    { id: "home", label: "HOME" },
    { id: "shop", label: "SHOP — $40" },
    { id: "custom", label: "CUSTOM STICKS" },
    { id: "brand", label: "THE BRAND" },
    { id: "game", label: "GAME" },
];

export default function ArcadeNav({ active, onNavigate, prefix = "nav" }) {
    return (
        <nav
            data-testid="arcade-nav"
            className="mx-auto flex w-full max-w-3xl flex-wrap items-stretch justify-center gap-2 sm:gap-2.5"
        >
            {TABS.map((t) => {
                const isGame = t.id === "game";
                return (
                    <button
                        key={t.id}
                        data-testid={`${prefix}-${t.id}-button`}
                        onClick={() => onNavigate(t.id)}
                        className={`${
                            isGame
                                ? "min-w-0 flex-none px-3"
                                : "min-w-[110px] flex-1 px-3 sm:px-4"
                        } border-2 py-2.5 font-jbmono text-[10px] uppercase tracking-[0.18em] transition-[background-color,color,border-color,transform] duration-150 hover:-translate-y-0.5 sm:text-[11px] ${
                            active === t.id
                                ? "border-[#FFD60A] bg-[#FFD60A] text-[#0A0A0C]"
                                : isGame
                                  ? "border-[#2A2A36] bg-[#0B0B0E] text-[#A1A1B2]/60 hover:border-[#A1A1B2] hover:text-[#F2F2F7]"
                                  : "border-[#2A2A36] bg-[#0B0B0E] text-[#A1A1B2] hover:border-[#FF3B30] hover:text-[#FF3B30]"
                        }`}
                    >
                        {t.label}
                    </button>
                );
            })}
        </nav>
    );
}
